import Text from 'components/Text/Text';
import React from 'react';
import classNames from 'classnames';
import DnDList from './components/DnDList/DnDList';
import style from './ChangePositionList.module.scss';

const ChangePositionList: React.FC = () => {
	const comboGroupHeadingClasses = classNames(style.comboGroup, style.heading);
	const restaurantHeadingClasses = classNames(style.restaurant, style.heading);
	const customerHeadingClasses = classNames(style.customer, style.heading);

	return (
		<div className={style.container} data-test="ChangePositionList">
			<div className={style.tableHeaders}>
				<Text
					className={comboGroupHeadingClasses}
					translationNameSpace="listing"
					translationKey="comboGroupLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantHeadingClasses}
					translationNameSpace="listing"
					translationKey="restaurantLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={customerHeadingClasses}
					translationNameSpace="listing"
					translationKey="customerLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			<DnDList />
		</div>
	);
};

export default ChangePositionList;
